/* Reliance — aperçu rapide d'un produit.
   Tout bouton [data-rel-quickview="<handle>"] (snippets/rel-quickview-button.liquid) ouvre une fenêtre <dialog>
   unique, remplie par l'API Section Rendering : /products/<handle>?section_id=rel-quickview
   (sections/rel-quickview.liquid). Contenu mis en cache par produit le temps de la page.
   Ajout au panier : /cart/add.js avec les sections de la fenêtre d'ajout du thème (cart-notification),
   puis ouverture de celle-ci ; sans elle (thème en tiroir ou page panier), redirection vers /cart. */
(function () {
  if (window.relQuickview) return;
  window.relQuickview = true;

  var cache = {};
  var dialog;
  var box;
  var lastTrigger = null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function build(closeLabel) {
    dialog = document.createElement('dialog');
    dialog.className = 'rel-qv-dialog';
    dialog.innerHTML =
      '<div class="rel-qv-dialog__box">' +
      '<div class="rel-qv-dialog__bar"><button type="button" class="rel-qv-dialog__close" data-rel-qv-close aria-label="' +
      (closeLabel || 'Fermer').replace(/"/g, '&quot;') +
      '"><svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.4"/></svg></button></div>' +
      '<div class="rel-qv-dialog__content" data-rel-qv-content></div>' +
      '</div>';
    document.body.appendChild(dialog);
    box = dialog.querySelector('[data-rel-qv-content]');

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-rel-qv-close]')) close();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('rel-qv-locked');
      if (lastTrigger) lastTrigger.focus();
      lastTrigger = null;
    });
    dialog.addEventListener('change', function (event) {
      var input = event.target;
      if (input.name !== 'id' || input.type !== 'radio') return;
      var price = dialog.querySelector('[data-rel-qv-price]');
      if (price && input.dataset.price) price.textContent = input.dataset.price;
    });
    dialog.addEventListener('submit', onSubmit);
  }

  function close() {
    if (dialog.open) dialog.close();
  }

  function show() {
    document.documentElement.classList.add('rel-qv-locked');
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=rel-quickview')
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var content = html.querySelector('.rel-qv');
        if (!content) throw new Error('rel-qv');
        cache[handle] = content.outerHTML;
        return cache[handle];
      });
  }

  function open(handle, trigger) {
    if (!dialog) build(trigger.getAttribute('data-rel-qv-close-label'));
    lastTrigger = trigger;
    box.innerHTML = '<p class="rel-qv-dialog__loading" aria-busy="true"></p>';
    dialog.removeAttribute('aria-labelledby');
    show();
    load(handle)
      .then(function (html) {
        box.innerHTML = html;
        var title = box.querySelector('.rel-qv__title');
        if (title) dialog.setAttribute('aria-labelledby', title.id);
        var focusTarget = box.querySelector('.rel-qv__add') || dialog.querySelector('[data-rel-qv-close]');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
        // Toujours ouvrir en haut (image et titre visibles), même après le focus initial de showModal
        dialog.scrollTop = 0;
      })
      .catch(function () {
        // Repli : la fiche produit
        window.location.href = root + 'products/' + encodeURIComponent(handle);
      });
  }

  function onSubmit(event) {
    var form = event.target.closest('[data-rel-qv-form]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('.rel-qv__add');
    var error = form.querySelector('[data-rel-qv-error]');
    var idInput = form.querySelector('[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]');
    if (!idInput) return;
    var notification = document.querySelector('cart-notification');
    var body = { items: [{ id: Number(idInput.value), quantity: 1 }] };
    if (notification && notification.getSectionsToRender) {
      body.sections = notification.getSectionsToRender().map(function (section) { return section.id; });
      body.sections_url = window.location.pathname;
    }
    button.disabled = true;
    button.classList.add('is-loading');
    if (error) error.hidden = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (data) {
        lastTrigger = null;
        close();
        if (notification && data.sections && data.items && data.items[0] && !document.querySelector('cart-items')) {
          data.key = data.items[0].key;
          notification.renderContents(data);
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function (data) {
        if (error) {
          if (data && data.description) error.textContent = data.description;
          error.hidden = false;
        }
      })
      .finally(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-rel-quickview]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    open(trigger.getAttribute('data-rel-quickview'), trigger);
  });

  // Ouverture depuis un autre script : petit panier des cartes produit à plusieurs formats (quick-add.js)
  window.relQuickview = { open: open };
})();
